<template>
  <div id="menu">
    <el-menu default-active="1-4-1" class="el-menu-vertical" :collapse="$store.state.iscollapse" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" :unique-opened="true" :default-openeds="opens">
      <template v-if="appRoles" v-for="(app, index) in appRoles">
        <el-submenu v-if="app.children" :index='(index+1).toString()'>
          <template slot="title">
            <i :class="app.icon"></i>
            <span> {{app.name}}</span>
          </template>
          <div v-for="(child, inx) in app.children">
            <el-menu-item :index="index.toString() + '-' + inx.toString()" @click="sendurl(app.icon,app.name,child)">
              <i :class="child.icon"></i>
              <span>{{child.name}}</span>
            </el-menu-item>
          </div>
        </el-submenu>
        <el-menu-item v-if="!app.children" :index='(index+1).toString()'>
          <i :class="app.icon"></i>
          <span>{{app.name}}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      opens: []
    };
  },
  props: {
    appRoles: Array
  },
  methods: {
    sendurl: function(pIcon, pName, child) {
      let info = {
        pIcon: pIcon,
        pName: pName,
        child: child
      };
      this.$emit("getmenu", info);
    }
  }
};
</script>

<style scoped>
.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
#menu {
  background-color: #545c64;
}
i {
  color: #fff;
  margin-left: 5px;
}
i span {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/mysys/Menu.vue